/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import CurrencyFormat from './utils/CurrencyFormat';
import CompareModal from './modal/CompareModal';
import AdicionalesModal from './modal/AdicionalesModal';
import useCarsData from '../hooks/useCarsData';

const SelectedCarModel = (props) => {

    const { getSelectedCar } = useCarsData();

    const selectedCar = getSelectedCar();

    const [showModalCompare, setShowModalCompare] = useState(false);
    const [showModalAdicionales, setShowModalAdicionales] = useState(false);


    const toggleModalCompare = () => {
        setShowModalCompare(!showModalCompare);
    }

    const toggleModalAdicionales = () => {
        setShowModalAdicionales(!showModalAdicionales);
    }

    const addDataLayer = () => {
        // SEO google dataLayer
        dataLayer.push({
            'event': 'trackEvent',
            'eventCategory': 'cotizar_share',
            'eventAction': 'ver_ficha_tecnica',
            'eventLabel': selectedCar.name
        });
    }

    return (
        <>
            <div className={"selected-car-model no-print " + (selectedCar ? "" : "disabled")}>
                <div className="model-image">
                    <img src={selectedCar ? selectedCar.photo_1.url : `${window._env_.STATIC_HOST}/static/kinto/img/cotizador/default_selected_car2.png`} alt={selectedCar ? selectedCar.name : null}></img>
                </div>
                {selectedCar ? (
                    <div className="model-actions">
                        {selectedCar.spec_url ? (
                            <div className="spec-link">
                                <a 
                                    href={selectedCar.spec_url} 
                                    target="_blank" 
                                    onClick={addDataLayer}
                                >
                                    Ver ficha técnica del modelo
                                </a>
                            </div>
                        ) : null}
                        <div className="compare-models-link">
                            <a onClick={toggleModalCompare}>
                                <span>
                                    Comparar modelos{" "}
                                    <i>
                                        <img src={`${window._env_.STATIC_HOST}/static/kinto/img/cotizador/chevron-navy.svg`}></img>
                                    </i>
                                </span>
                            </a>
                        </div>
                    </div>
                ) : null}

            </div>
            {selectedCar ? (
                <>
                    <div className={"no-print extras " + (selectedCar ? "" : "disabled")}>
                        <div className="price-card">
                            <div className="list-price">
                                <p>
                                    <CurrencyFormat value={selectedCar.hourly_rate} />
                                </p>
                                <small>por hora</small>
                            </div>
                            <div className="list-price">
                                <p>
                                    <CurrencyFormat value={selectedCar.daily_rate} />
                                </p>
                                <small>por día</small>
                            </div>
                            <small className="franchise">{/* Franquicia de <CurrencyFormat value={selectedCar.max_insurance_cost} /> */}</small>
                        </div>
                        <div className="add-extra">
                            {/* <a
                                onClick={toggleModalAdicionales}
                                className="button button--dark button--outline"
                                style={{ paddingTop:'0.08rem' }}
                            >
                                Agregar adicionales
                            </a> */}
                        </div>
                    </div>
                    {showModalCompare ? (
                        <CompareModal onClose={toggleModalCompare} />
                    ) : null}

                    {/* {showModalAdicionales ? (
                        <AdicionalesModal onClose={toggleModalAdicionales}/>
                    ) : null} */}
                </>
            ) : null}

        </>
    );

}

export default SelectedCarModel;